<template>
  <teleport to="body">
    <transition name="fade">
      <!-- popup background -->
      <div
        v-if="isVisible"
        class="container-fluid"
      >
        <div
          class="bb-popup-bg d-flex justify-content-center align-items-center"
          :style="backdropStyle"
        >
          <!-- popup box -->
          <div
            class="card shadow bb-card mb-2 rounded"
            :style="popupStyle"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'PopUpModal',

  props: {
    width: {
      type: String,
      default: '24rem',
    },
    maxWidth: {
      type: String,
      default: '95vw',
    },
    minHeight: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
    horizontalAlign: {
      type: String,
      default: 'center',
    },
    horizontalOffset: {
      type: String,
      default: null,
    },
    verticalAlign: {
      type: String,
      default: 'center',
    },
    allowViewportScroll: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: [String, Number],
      default: 11000,
    },
  },

  data: () => ({
    isVisible: false,
  }),

  computed: {
    backdropStyle() {
      const justifyContentMap = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
      }
      const alignItemsMap = {
        top: 'flex-start',
        center: 'center',
        bottom: 'flex-end',
      }

      return {
        '--bb-popup-z-index': String(this.zIndex),
        justifyContent: justifyContentMap[this.horizontalAlign] || 'center',
        alignItems: alignItemsMap[this.verticalAlign] || 'center',
        overflowY: this.allowViewportScroll ? 'auto' : 'hidden',
        paddingTop: this.allowViewportScroll ? '0.75rem' : null,
        paddingBottom: this.allowViewportScroll ? '0.75rem' : null,
      }
    },
    popupStyle() {
      const sideSpacing = '1.5rem'
      const viewportWidth = 'calc(100vw - 1rem)'
      const viewportHeight = 'calc(100vh - 1rem)'
      const resolvedWidth = this.width
        ? `min(${this.width}, ${viewportWidth})`
        : viewportWidth
      const resolvedHeight = this.height
        ? this.allowViewportScroll
          ? this.height
          : `min(${this.height}, ${viewportHeight})`
        : null
      const resolvedMaxWidth = this.maxWidth
        ? `min(${this.maxWidth}, ${viewportWidth})`
        : viewportWidth

      return {
        width: resolvedWidth,
        maxWidth: resolvedMaxWidth,
        minHeight: this.minHeight,
        height: resolvedHeight,
        maxHeight: this.allowViewportScroll ? 'none' : viewportHeight,
        marginLeft: this.horizontalAlign === 'left' ? sideSpacing : null,
        marginRight: this.horizontalAlign === 'right' ? sideSpacing : null,
        transform: this.horizontalOffset
          ? `translateX(${this.horizontalOffset})`
          : null,
        position: 'relative',
        overflow: this.allowViewportScroll ? 'visible' : 'hidden',
        boxSizing: 'border-box',
      }
    },
  },

  methods: {
    open() {
      this.isVisible = true
    },

    close() {
      this.isVisible = false
    },
  },
}
</script>
